import { render, staticRenderFns } from "./Incapacidad.vue?vue&type=template&id=30806609"
import script from "./Incapacidad.vue?vue&type=script&lang=js"
export * from "./Incapacidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports